import type { PropsWithChildren } from "react";

export function PanelLoadingMessage({ children }: PropsWithChildren): JSX.Element {
  return (
    <div className="flex animate-pulse items-center justify-center py-10 text-xs font-normal text-gray-500">
      {children}
    </div>
  );
}
